import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { CostEventObjectTypeSettingsPage } from "src/components/views/erp/common/costEvents/CostEventObjectTypeSettingsPage.tsx";

export const Route = createFileRoute("/_authenticated/_shell/erp/common/costEventObjectTypeSettings")({
	staticData: { title: i18n.t("settings"), legacyViewKey: "costEventObjectTypeSettingsPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <CostEventObjectTypeSettingsPage />;
}
